module.exports = __webpack_public_path__ + "static/media/brainflix-macbook-hero.535d11a4.jpg";